import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useMomentTrashContextMenu = () => {
  const [selectedMoment, setSelectedMoment] = useState<any>(null);
  const [isMomentDeleteConfirm, setIsMomentDeleteConfirm] =
    useState<boolean>(false);
  const [restoreMomentId, setRestoreMomentId] = useState<string>('');
  const [isMomentRestoreConfirm, setIsMomentRestoreConfirm] =
    useState<boolean>(false);

  const { deleteItem, restoreItem } = useTrashRestoreDelete();

  const handleDeleteMoment = (
    momentId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteItem({
      module: 'moments',
      moduleId: momentId,
      onSuccess: () => {
        setSelectedMoment(null);
        setIsMomentDeleteConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestoreMoment = (
    momentId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreItem({
      module: 'moments',
      moduleId: momentId,
      onSuccess: () => {
        setRestoreMomentId('');
        setIsMomentRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsMomentRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const momentContextMenuItems = useCallback(
    (moment: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestoreMomentId(moment?.id);
          setIsMomentRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedMoment(moment);
          setIsMomentDeleteConfirm(true);
        }
      }
    ],
    []
  );

  return {
    momentContextMenuItems,
    selectedMoment,
    setSelectedMoment,
    isMomentDeleteConfirm,
    setIsMomentDeleteConfirm,
    restoreMomentId,
    setRestoreMomentId,
    isMomentRestoreConfirm,
    setIsMomentRestoreConfirm,
    handleDeleteMoment,
    handleRestoreMoment
  };
};
